export default __webpack_public_path__ + "static/media/location-light.30f2009e.svg";